import {analyticsLogEvent} from '../api'
import {AnalyticsEventInitProps} from '_types'

export function analyticsEventInit({
    country,
    currency,
    pageCategory,
    pageSubCategory,
    pageDetail,
    pageLanguage,
    pageStatus,
    listingType,
    menuWidget,
    sortingEngine,
    sortingType,
}: AnalyticsEventInitProps) {
    const eventDetails = {
        visitorShipping: country,
        visitorCurrency: currency,
        pageCategory: pageCategory,
        pagesubCategory: pageSubCategory,
        pageDetail: pageDetail,
        pageLanguage: pageLanguage,
        pageStatus: pageStatus,
        listingType: listingType,
        menu_widget: menuWidget,
        sorting_engine: sortingEngine,
        ...(sortingType ? {sorting_type: sortingType} : {}),
    }

    analyticsLogEvent('init', eventDetails)
}
